export default __webpack_public_path__ + "static/media/error.28ae1ef4.wav";